import {appAPI} from "../../../api";
import {IHoliday, IPeriod, ISchedule, IStageShift, IStatsCar, IStatsCarDetail, IStatsSummary, WorkDays} from "../model/types";

/** HTTP Статы (src/stats/stats.controller.ts, S17.1). Ошибки — текстом из `message` в thunk'ах. */
export const statsAPI = {
    getCars: async (period: IPeriod): Promise<IStatsCar[]> => (await appAPI.get("/stats/cars", {params: period})).data,
    getCar: async (id: string): Promise<IStatsCarDetail> => (await appAPI.get(`/stats/cars/${id}`)).data,
    /** `ids` — сводка по выбранным POST-ом (период не применяется; в URL сотни uuid не влезали, S17.2.1), иначе — GET за период. */
    getSummary: async (period: IPeriod, ids: string[]): Promise<IStatsSummary> =>
        (ids.length
            ? await appAPI.post("/stats/summary", {ids})
            : await appAPI.get("/stats/summary", {params: period})).data,

    getSchedule: async (): Promise<ISchedule> => (await appAPI.get("/stats/schedule")).data,
    saveShift: async (stage: string, dto: {work_days: WorkDays; start: string; end: string}): Promise<IStageShift> =>
        (await appAPI.put(`/stats/schedule/${stage}`, dto)).data,
    addHoliday: async (date: string, title: string): Promise<IHoliday> =>
        (await appAPI.post("/stats/holidays", {date, title})).data,
    removeHoliday: async (id: string): Promise<{id: string}> => (await appAPI.delete(`/stats/holidays/${id}`)).data,
};
